import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const InviteWrapper = styled.div`
    display:flex;
    flex-direction:row;
    cursor:pointer;
`

export const UserInfoWrapper = styled.div`
    display:flex;
    gap: 10px;
    cursor:pointer;
`


export const EllipsisWrapper = styled.div`
    display:flex;
`

export const ModalSubtitle = styled.div`
    font-size: 12px;
    color: ${theme.colors.dkgrey};
    font-family:"Poppins";
    font-weight:400;
`

export const ModalTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    font-family: "Rubik";
    color: ${theme.colors.base_800};
`

export const ModalIcon = styled.div`
    width:18px;
    height:18px;
    svg{
    fill:black !important;}
    display:flex;
    margin-right:10px;
`

export const ModalTitleWrapper = styled.div` 
    display:flex;   
    flex-direction:column;
    margin-bottom:10px;
`